import React from 'react';
import { friendlyErrorMessage } from '../utils/apiErrorDetail';

interface ErrorDisplayProps {
  error: Error | undefined;
  onRetry: () => void;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error, onRetry }) => {
  if (!error) return null;

  return (
    <div className="bg-red-50 border-l-4 border-red-400 p-4 mx-6 mt-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <div className="w-5 h-5 bg-red-400 rounded-full flex items-center justify-center">
            <span className="text-white text-sm font-bold">!</span>
          </div>
        </div>
        <div className="ml-3">
          {/* Never `Error: {error.message}` — that put status lines and stack
              text on screen. Everything shown here goes through the friendly
              mapping first. */}
          <p className="text-sm text-red-700">
            {friendlyErrorMessage(error)}
          </p>
          <button
            onClick={onRetry}
            className="mt-2 text-sm text-red-600 hover:text-red-500 underline"
          >
            Retry
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorDisplay;
